/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Type_UnknownInputs */

const en_task_type_unknown = /** @type {(inputs: Task_Type_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity does not exist.`)
};

const pt_br2_task_type_unknown = /** @type {(inputs: Task_Type_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não existe.`)
};

/**
* | output |
* | --- |
* | "This activity does not exist." |
*
* @param {Task_Type_UnknownInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_type_unknown = /** @type {((inputs?: Task_Type_UnknownInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Type_UnknownInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_type_unknown(inputs)
	return pt_br2_task_type_unknown(inputs)
});